module.exports = __webpack_public_path__ + "static/media/loading-arrow.e9ea7394.gif";